import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
// import ListItemText from '@material-ui/core/ListItemText';
import item from './AdminMenu';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({}))(MenuItem);

class AdminTopbarMenu extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { anchorEl, onClose } = this.props;

    return (
      <>
        <StyledMenu id="customized-menu" className={'drawer'} anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
          {item.map((item, index) => {
            if (index > 0 && index < 6) {
              return (
                <MenuItem
                  key={`styled-menu-${index}`}
                  onClick={() => {
                    this.props.history.push(`${item.pathname}Status`);
                  }}
                  key={`drawer-menu-${item.label}`}
                >
                  {item.label}
                </MenuItem>
              );
            }
          })}
        </StyledMenu>
      </>
    );
  }
}

export default withRouter(AdminTopbarMenu);
